<template>
    <BaseWidget :title="widget.title" :title-url="widget.titleUrl" :footer="widget.footer">
        <div class="-mx-2 space-y-px" v-for="(programming, index) in widget.content.calendarDay.sessions">
            <div class="text-xs">{{ index }}</div>
            <ul>
                <li v-for="session in programming">
                    <InertiaLink :href="session.session.links.show">
                        <BadgePill :color="session.group.color">
                            {{ session.group.name }} - {{ session.subject }}
                        </BadgePill>
                    </InertiaLink>
                </li>
            </ul>
        </div>
    </BaseWidget>
</template>

<script>
import BaseWidget from '@/components/Widgets/BaseWidget.vue';
import BadgePill from '@/components/BadgePill.vue';

export default {
    name: 'ProgrammingCalendarDayWidget',
    components: {
        BaseWidget,
        BadgePill,
    },
    props: {
        widget: {
            required: true,
            type: Object,
        },
    },
};
</script>
